<i18n>
{
	"en": {
		"freeText": "Free text",
		"noFreeText": "There are no free texts yet.",
		"invoice": "Invoice",
		"waybill": "Waybill",
		"loadingList": "Loading list",
		"internal": "Internal",
		"goodsList": "Goods list"
	},
	"no": {
		"freeText": "Fritekst",
		"noFreeText": "Det er ingen fritekster ennå.",
		"invoice": "Faktura",
		"waybill": "Fraktbrev",
		"loadingList": "Lasteliste",
		"internal": "Internt",
		"goodsList": "Godsliste"
	}
}
</i18n>

<template>
	<div class="free-text-sub-order">
		<MultipleTextAreas
			:textAreas="textAreas"
			textAreaKeyToFocus="transporterInstructions"
			@textAreaChange="setFreeText({ key: $event.key, freeText: $event.value })"
		/>
	</div>
</template>

<script>
import { mapState, mapMutations } from '../store/orderTemplates.store';
import MultipleTextAreas from '@/modules/newOrder/common/MultipleTextAreas';

export default {
	name: 'FreeText',
	components: { MultipleTextAreas },
	computed: {
		...mapState(['templateDetails']),
		textAreas() {
			return [
				{
					key: 'transporterInstructions',
					value: this.templateDetails.transporterInstructions,
					name: this.$t('waybill')
				},
				{
					key: 'invoiceFreeText',
					value: this.templateDetails.invoiceFreeText,
					name: this.$t('invoice')
				},
				{
					key: 'loadingListFreeText',
					value: this.templateDetails.loadingListFreeText,
					name: this.$t('loadingList')
				},
				{
					key: 'internalNotes',
					value: this.templateDetails.internalNotes,
					name: this.$t('internal')
				},
				{
					key: 'goodsListFreeText',
					value: this.templateDetails.goodsListFreeText,
					name: this.$t('goodsList')
				}
			];
		},
	},
	methods: {
		...mapMutations(['setFreeText']),
	}
};
</script>

<style lang="scss" scoped>

.free-text-sub-order {
	height: 100%;
	width: 100%;
	min-height: inherit;
}

</style>
